var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Slider"
  }, [_c('div', {
    staticClass: "Slider-content",
    attrs: {
      "id": ("js-slider-" + (_vm.inputId))
    }
  }, [_vm._t("default")], 2), _vm.withDots ? _c('dots', {
    staticClass: "Slider-dots",
    attrs: {
      "globalTabIndex": _vm.globalTabIndex,
      "color": 'pink',
      "stepIndex": _vm.getActiveSlide,
      "steps": _vm.itemsLength
    },
    on: {
      "dotClicked": _vm.slideTo
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }